import {
  buildDashboardSettingPayload,
  getDashboardSettingValidationMessage,
  isDashboardAdEnabled,
  parseDashboardVideo
} from './dashboard-setting-values';

export function createAccountDashboardSetting(OriginalDashboardSetting, { api, Notify, getVideoId }) {
  if (!OriginalDashboardSetting) return OriginalDashboardSetting;
  return {
    name: 'DashboardSettingOverride',
    extends: OriginalDashboardSetting,

    data() {
      return {
        model: {
          dashboard_ad_video_embed: '',
          dashboard_ad_paid_video_embed: ''
        },
        savingDashboardSetting: false
      };
    },

    methods: {
      async UpdateAddSetting() {
        if (this.savingDashboardSetting) return;

        const settingType = String(this.model.dashboard_setting_type);
        const enabled = isDashboardAdEnabled(
          this.model.is_dashboard_ad_enabled
        );
        const iframeUrl = (this.model.dashboard_ad_iframe_url || '').trim();
        const videoDetails = parseDashboardVideo(
          this.model.dashboard_ad_video_embed, getVideoId
        );
        const paidVideoDetails = parseDashboardVideo(
          this.model.dashboard_ad_paid_video_embed, getVideoId
        );
        const validationMessage = getDashboardSettingValidationMessage(
          enabled,
          settingType,
          iframeUrl,
          videoDetails
        );

        if (validationMessage) {
          Notify.fail(validationMessage);
          return;
        }

        const endpoint = this.model.id
          ? 'dashboard-setting-update'
          : 'dashboard-setting-save';
        const payload = buildDashboardSettingPayload(
          this.model,
          videoDetails,
          paidVideoDetails
        );

        this.savingDashboardSetting = true;

        try {
          const response = await api.post(
            `${window.gdEnv.VUE_APP_API_URL}/groovesell/${endpoint}`,
            payload
          );
          this.showSuccess(response);
          this.close();
          window.location.reload();
        } catch (error) {
          this.showError(error);
        } finally {
          this.savingDashboardSetting = false;
        }
      }
    }
  };
}
